// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"5209374d","168":"392eb1fa","324":"7b470a6d","334":"faed5182","453":"1d663c77","470":"79a9c14c","537":"35298047","714":"b4747dcc","794":"baeef2a6","872":"cadd4f63","927":"05757555"}[chunkId] + ".chunk.js";
};